// // Mock data for Bitcoin Africa Story website

// export const blogPosts = [
//   {
//     id: '1',
//     title: 'Bitcoin Basics: Your First Steps into Financial Freedom',
//     slug: 'bitcoin-basics-first-steps',
//     excerpt: 'Learn the fundamentals of Bitcoin and how it can transform your financial future. A beginner-friendly guide to understanding digital currency.',
//     content: 'Full blog content here...',
//     category: 'Bitcoin Basics',
//     image: 'https://images.unsplash.com/photo-1640161704729-cbe966a08476?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2025-08-15',
//     readTime: '5 min read'
//   },
//   {
//     id: '2',
//     title: 'How Bitcoin is Changing Lives Across Africa',
//     slug: 'bitcoin-changing-lives-africa',
//     excerpt: 'Real stories of Africans who embraced Bitcoin and transformed their financial situations. Discover the power of decentralized money.',
//     content: 'Full blog content here...',
//     category: 'Adoption Stories',
//     image: 'https://images.unsplash.com/photo-1540058404349-2e5fabf32d75?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2025-08-10',
//     readTime: '7 min read'
//   },
//   {
//     id: '3',
//     title: 'Breaking Free: Bitcoin and Financial Independence',
//     slug: 'bitcoin-financial-independence',
//     excerpt: 'Explore how Bitcoin empowers individuals to take control of their wealth and break free from traditional financial constraints.',
//     content: 'Full blog content here...',
//     category: 'Freedom & Money',
//     image: 'https://images.unsplash.com/photo-1623227413711-25ee4388dae3?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2025-08-05',
//     readTime: '6 min read'
//   },
//   {
//     id: '4',
//     title: 'Smart Saving Strategies with Bitcoin',
//     slug: 'smart-saving-strategies-bitcoin',
//     excerpt: 'Learn practical strategies for saving and building wealth using Bitcoin. Tips for long-term holders and beginners alike.',
//     content: 'Full blog content here...',
//     category: 'Saving & Investing',
//     image: 'https://images.unsplash.com/photo-1609726494499-27d3e942456c?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2025-07-28',
//     readTime: '8 min read'
//   },
//   {
//     id: '5',
//     title: 'Keeping Your Bitcoin Safe: Essential Security Tips',
//     slug: 'bitcoin-security-tips',
//     excerpt: 'Protect your Bitcoin with these essential security practices. Learn about wallets, keys, and best practices for keeping your funds safe.',
//     content: 'Full blog content here...',
//     category: 'Bitcoin Basics',
//     image: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2025-07-20',
//     readTime: '10 min read'
//   },
//   {
//     id: '6',
//     title: 'Building Bitcoin Communities in Africa',
//     slug: 'building-bitcoin-communities-africa',
//     excerpt: 'The power of community in Bitcoin adoption. How grassroots movements are spreading Bitcoin education across the continent.',
//     content: 'Full blog content here...',
//     category: 'Adoption Stories',
//     image: 'https://images.unsplash.com/photo-1634936016780-65f6a77ebdd4?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2025-07-15',
//     readTime: '6 min read'
//   }
// ];

// export const categories = [
//   'All',
//   'Bitcoin Basics',
//   'Adoption Stories',
//   'Freedom & Money',
//   'Saving & Investing'
// ];

// export const testimonials = [
//   {
//     id: '1',
//     name: 'Amara O.',
//     location: 'Lagos, Nigeria',
//     text: 'Learning about Bitcoin changed my perspective on money. Now I have control over my financial future.',
//     avatar: 'AO'
//   },
//   {
//     id: '2',
//     name: 'Kwame M.',
//     location: 'Accra, Ghana',
//     text: 'The education I received here helped me understand Bitcoin deeply. I can now teach others in my community.',
//     avatar: 'KM'
//   },
//   {
//     id: '3',
//     name: 'Fatima S.',
//     location: 'Nairobi, Kenya',
//     text: 'Bitcoin gave me financial freedom I never thought possible. This education was life-changing.',
//     avatar: 'FS'
//   }
// ];

// export const resources = [
//   {
//     id: '1',
//     title: 'Bitcoin Beginner Guide (PDF)',
//     description: 'A comprehensive guide for anyone starting their Bitcoin journey',
//     type: 'PDF',
//     downloadUrl: '#'
//   },
//   {
//     id: '2',
//     title: 'Recommended Bitcoin Wallets',
//     description: 'Top secure wallets for storing your Bitcoin safely',
//     type: 'Guide',
//     downloadUrl: '#'
//   },
//   {
//     id: '3',
//     title: 'Security Best Practices',
//     description: 'Essential security tips every Bitcoin user should know',
//     type: 'PDF',
//     downloadUrl: '#'
//   },
//   {
//     id: '4',
//     title: 'Bitcoin Glossary',
//     description: 'Common Bitcoin terms and their meanings explained simply',
//     type: 'Reference',
//     downloadUrl: '#'
//   }
// ];

// export const features = [
//   {
//     id: '1',
//     title: 'Freedom',
//     description: 'Take control of your money without banks or intermediaries. Bitcoin gives you true financial sovereignty.',
//     image: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=600&q=80'
//   },
//   {
//     id: '2',
//     title: 'Savings',
//     description: 'Protect your wealth from inflation and currency devaluation. Build a secure financial future.',
//     image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&q=80'
//   },
//   {
//     id: '3',
//     title: 'Ownership',
//     description: 'You hold your own keys, you own your Bitcoin. No one can freeze or seize your funds.',
//     image: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=600&q=80'
//   },
//   {
//     id: '4',
//     title: 'Opportunity',
//     description: 'Access global financial opportunities. Bitcoin opens doors to economic participation for everyone.',
//     image: 'https://images.unsplash.com/photo-1635305587352-d8d25f4d1661?w=600&q=80'
//   }
// ];



// Mock data for Bitcoin Africa Story website

// export const blogPosts = [
//   // ADOPTION STORIES
//   {
//     id: '1',
//     title: 'How Bitcoin Saved My Small Business During Currency Crisis',
//     slug: 'bitcoin-saved-small-business',
//     excerpt: 'When my local currency lost 60% of its value, Bitcoin became my lifeline. Here\'s how I protected my business and continued serving customers.',
//     content: 'Full blog content here...',
//     category: 'Adoption',
//     image: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?w=800&q=80',
//     author: 'Small Business Owner',
//     date: '2024-11-15',
//     readTime: '5 min read'
//   },
//   {
//     id: '2',
//     title: 'Kenya Leads Africa in Bitcoin Adoption with New Mobile Payment Integration',
//     slug: 'kenya-bitcoin-mobile-payment',
//     excerpt: 'Kenya\'s M-Pesa users can now seamlessly buy and use Bitcoin, marking a major milestone in African cryptocurrency adoption.',
//     content: 'Full blog content here...',
//     category: 'Adoption',
//     image: 'https://images.unsplash.com/photo-1540058404349-2e5fabf32d75?w=800&q=80',
//     author: 'Bitcoin Reporter',
//     date: '2024-11-12',
//     readTime: '7 min read'
//   },
//   {
//     id: '3',
//     title: 'Teaching My Village About Digital Money',
//     slug: 'teaching-village-digital-money',
//     excerpt: 'How one woman is bringing Bitcoin education to rural communities and empowering people to take control of their financial future.',
//     content: 'Full blog content here...',
//     category: 'Adoption',
//     image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=80',
//     author: 'Community Educator',
//     date: '2024-11-08',
//     readTime: '6 min read'
//   },

//   // REGULATIONS
//   {
//     id: '4',
//     title: 'Nigerian Government Clarifies Bitcoin Regulation Framework',
//     slug: 'nigerian-bitcoin-regulation',
//     excerpt: 'New guidelines provide clarity for Bitcoin users and businesses in Nigeria, signaling a more progressive approach to cryptocurrency.',
//     content: 'Full blog content here...',
//     category: 'Regulations',
//     image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
//     author: 'Policy Analyst',
//     date: '2024-11-10',
//     readTime: '8 min read'
//   },
//   {
//     id: '5',
//     title: 'South African Retailers Report 65% Increase in Bitcoin Payments',
//     slug: 'south-africa-bitcoin-payments',
//     excerpt: 'Major retail chains across South Africa are embracing Bitcoin payments as consumer demand surges amid economic uncertainty.',
//     content: 'Full blog content here...',
//     category: 'Regulations',
//     image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
//     author: 'Business Reporter',
//     date: '2024-11-05',
//     readTime: '5 min read'
//   },
//   {
//     id: '6',
//     title: 'From Remittances to Financial Freedom',
//     slug: 'remittances-financial-freedom',
//     excerpt: 'African diaspora discovers Bitcoin as a faster, cheaper way to send money home, saving millions in transfer fees annually.',
//     content: 'Full blog content here...',
//     category: 'Regulations',
//     image: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=800&q=80',
//     author: 'Financial Journalist',
//     date: '2024-11-01',
//     readTime: '6 min read'
//   },

//   // EDUCATION & GUIDES
//   {
//     id: '7',
//     title: 'A Journalist\'s Shield: Receiving Anonymous Tips with Bitcoin',
//     slug: 'journalist-bitcoin-tips',
//     excerpt: 'How investigative journalists across Africa are using Bitcoin to protect sources and maintain financial independence.',
//     content: 'Full blog content here...',
//     category: 'Education',
//     image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&q=80',
//     author: 'Press Freedom',
//     date: '2024-10-28',
//     readTime: '8 min read'
//   },
//   {
//     id: '8',
//     title: 'From Learner to Leader: How a Bitcoin Meetup Changed My Life',
//     slug: 'bitcoin-meetup-changed-life',
//     excerpt: 'Attending a local Bitcoin meetup opened doors I never knew existed. Now I\'m helping others discover financial sovereignty.',
//     content: 'Full blog content here...',
//     category: 'Education',
//     image: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=800&q=80',
//     author: 'Community Leader',
//     date: '2024-10-25',
//     readTime: '7 min read'
//   },
//   {
//     id: '9',
//     title: 'Youth Building the Bitcoin Economy',
//     slug: 'youth-building-bitcoin-economy',
//     excerpt: 'African youth are leading the charge in Bitcoin adoption, creating innovative solutions for local challenges.',
//     content: 'Full blog content here...',
//     category: 'Education',
//     image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80',
//     author: 'Youth Reporter',
//     date: '2024-10-20',
//     readTime: '6 min read'
//   },
//   {
//     id: '10',
//     title: 'What is the Lightning Network? A Guide for Africans',
//     slug: 'lightning-network-guide',
//     excerpt: 'Understanding the Lightning Network and how it enables instant, low-cost Bitcoin transactions perfect for everyday use.',
//     content: 'Full blog content here...',
//     category: 'Education',
//     image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&q=80',
//     author: 'Bitcoin Educator',
//     date: '2024-10-15',
//     readTime: '10 min read'
//   },
//   {
//     id: '11',
//     title: 'Solar-Powered Bitcoin Mining: A Solution for Rural Africa?',
//     slug: 'solar-bitcoin-mining',
//     excerpt: 'Exploring how renewable energy and Bitcoin mining could bring economic opportunities to remote African communities.',
//     content: 'Full blog content here...',
//     category: 'Education',
//     image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&q=80',
//     author: 'Technology Writer',
//     date: '2024-10-10',
//     readTime: '9 min read'
//   }
// ];

// export const categories = [
//   'All',
//   'Adoption',
//   'Regulations',
//   'Education'
// ];

// export const testimonials = [
//   {
//     id: '1',
//     name: 'Amara O.',
//     location: 'Lagos, Nigeria',
//     text: 'Learning about Bitcoin changed my perspective on money. Now I have control over my financial future.',
//     avatar: 'AO'
//   },
//   {
//     id: '2',
//     name: 'Kwame M.',
//     location: 'Accra, Ghana',
//     text: 'The education I received here helped me understand Bitcoin deeply. I can now teach others in my community.',
//     avatar: 'KM'
//   },
//   {
//     id: '3',
//     name: 'Fatima S.',
//     location: 'Nairobi, Kenya',
//     text: 'Bitcoin gave me financial freedom I never thought possible. This education was life-changing.',
//     avatar: 'FS'
//   }
// ];

// export const resources = [
//   {
//     id: '1',
//     title: 'Bitcoin Beginner Guide (PDF)',
//     description: 'A comprehensive guide for anyone starting their Bitcoin journey',
//     type: 'PDF',
//     downloadUrl: '#'
//   },
//   {
//     id: '2',
//     title: 'Recommended Bitcoin Wallets',
//     description: 'Top secure wallets for storing your Bitcoin safely',
//     type: 'Guide',
//     downloadUrl: '#'
//   },
//   {
//     id: '3',
//     title: 'Security Best Practices',
//     description: 'Essential security tips every Bitcoin user should know',
//     type: 'PDF',
//     downloadUrl: '#'
//   },
//   {
//     id: '4',
//     title: 'Bitcoin Glossary',
//     description: 'Common Bitcoin terms and their meanings explained simply',
//     type: 'Reference',
//     downloadUrl: '#'
//   }
// ];

// export const features = [
//   {
//     id: '1',
//     title: 'Freedom',
//     description: 'Take control of your money without banks or intermediaries. Bitcoin gives you true financial sovereignty.',
//     image: 'https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=600&q=80'
//   },
//   {
//     id: '2',
//     title: 'Savings',
//     description: 'Protect your wealth from inflation and currency devaluation. Build a secure financial future.',
//     image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&q=80'
//   },
//   {
//     id: '3',
//     title: 'Ownership',
//     description: 'You hold your own keys, you own your Bitcoin. No one can freeze or seize your funds.',
//     image: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=600&q=80'
//   },
//   {
//     id: '4',
//     title: 'Opportunity',
//     description: 'Access global financial opportunities. Bitcoin opens doors to economic participation for everyone.',
//     image: 'https://images.unsplash.com/photo-1635305587352-d8d25f4d1661?w=600&q=80'
//   }
// ];




// Mock data for Bitcoin Africa Story website

export const blogPosts = [
  // ADOPTION STORIES
  {
    id: '1',
    title: 'How Bitcoin Saved My Small Business During Currency Crisis',
    slug: 'bitcoin-saved-small-business',
    excerpt: 'When my local currency lost 60% of its value, Bitcoin became my lifeline. Here\'s how I protected my business and continued serving customers.',
    content: 'Full blog content here...',
    category: 'Adoption',
    image: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?w=800&q=80',
    author: 'Small Business Owner',
    date: '2024-11-15',
    readTime: '5 min read'
  },
  {
    id: '2',
    title: 'Kenya Leads Africa in Bitcoin Adoption with New Mobile Payment Integration',
    slug: 'kenya-bitcoin-mobile-payment',
    excerpt: 'Kenya\'s M-Pesa users can now seamlessly buy and use Bitcoin, marking a major milestone in African cryptocurrency adoption.',
    content: 'Full blog content here...',
    category: 'Adoption',
    image: 'https://images.unsplash.com/photo-1540058404349-2e5fabf32d75?w=800&q=80',
    author: 'Bitcoin Reporter',
    date: '2024-11-12',
    readTime: '7 min read'
  },
  {
    id: '3',
    title: 'Teaching My Village About Digital Money',
    slug: 'teaching-village-digital-money',
    excerpt: 'How one woman is bringing Bitcoin education to rural communities and empowering people to take control of their financial future.',
    content: 'Full blog content here...',
    category: 'Adoption',
    image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=80',
    author: 'Community Educator',
    date: '2024-11-08',
    readTime: '6 min read'
  },
  {
    id: '4',
    title: 'From Street Vendor to Bitcoin Merchant: A Lagos Success Story',
    slug: 'street-vendor-bitcoin-merchant',
    excerpt: 'Meet the Lagos street vendor who tripled his income by accepting Bitcoin payments and teaching other vendors to do the same.',
    content: 'Full blog content here...',
    category: 'Adoption',
    image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800&q=80',
    author: 'Success Stories',
    date: '2024-11-05',
    readTime: '6 min read'
  },
  {
    id: '5',
    title: 'Bitcoin ATMs Arrive in Accra: First-Hand Experience',
    slug: 'bitcoin-atms-accra',
    excerpt: 'Ghana welcomes its first Bitcoin ATMs. We tested them and here\'s everything you need to know about using them safely.',
    content: 'Full blog content here...',
    category: 'Adoption',
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80',
    author: 'Tech Reporter',
    date: '2024-11-02',
    readTime: '5 min read'
  },
  {
    id: '6',
    title: 'How Bitcoin Helped Me Escape Inflation in Zimbabwe',
    slug: 'escape-inflation-zimbabwe',
    excerpt: 'A personal account of surviving hyperinflation by converting savings to Bitcoin and preserving wealth for the future.',
    content: 'Full blog content here...',
    category: 'Adoption',
    image: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=800&q=80',
    author: 'Zimbabwe Resident',
    date: '2024-10-28',
    readTime: '8 min read'
  },

  // REGULATIONS & POLICY
  {
    id: '7',
    title: 'Nigerian Government Clarifies Bitcoin Regulation Framework',
    slug: 'nigerian-bitcoin-regulation',
    excerpt: 'New guidelines provide clarity for Bitcoin users and businesses in Nigeria, signaling a more progressive approach to cryptocurrency.',
    content: 'Full blog content here...',
    category: 'Regulations',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
    author: 'Policy Analyst',
    date: '2024-11-10',
    readTime: '8 min read'
  },
  {
    id: '8',
    title: 'South African Retailers Report 65% Increase in Bitcoin Payments',
    slug: 'south-africa-bitcoin-payments',
    excerpt: 'Major retail chains across South Africa are embracing Bitcoin payments as consumer demand surges amid economic uncertainty.',
    content: 'Full blog content here...',
    category: 'Regulations',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    author: 'Business Reporter',
    date: '2024-11-05',
    readTime: '5 min read'
  },
  {
    id: '9',
    title: 'Central African Republic Bitcoin Law: One Year Later',
    slug: 'car-bitcoin-law-review',
    excerpt: 'Analyzing the impact and challenges of Central African Republic\'s Bitcoin adoption one year after making it legal tender.',
    content: 'Full blog content here...',
    category: 'Regulations',
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80',
    author: 'Legal Expert',
    date: '2024-11-01',
    readTime: '10 min read'
  },
  {
    id: '10',
    title: 'Ghana Tax Authority Issues New Guidelines for Bitcoin Traders',
    slug: 'ghana-bitcoin-tax-guidelines',
    excerpt: 'Understanding the new tax regulations for cryptocurrency trading in Ghana and how to stay compliant.',
    content: 'Full blog content here...',
    category: 'Regulations',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80',
    author: 'Tax Consultant',
    date: '2024-10-25',
    readTime: '7 min read'
  },

  // EDUCATION & GUIDES
  {
    id: '11',
    title: 'Bitcoin 101: Complete Beginner\'s Guide for Africans',
    slug: 'bitcoin-101-beginners-guide',
    excerpt: 'Everything you need to know to get started with Bitcoin. Simple explanations, no technical jargon.',
    content: 'Full blog content here...',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1501618669935-18b6ecb13d6d?w=800&q=80',
    author: 'Bitcoin Educator',
    date: '2024-11-14',
    readTime: '12 min read'
  },
  {
    id: '12',
    title: 'A Journalist\'s Shield: Receiving Anonymous Tips with Bitcoin',
    slug: 'journalist-bitcoin-tips',
    excerpt: 'How investigative journalists across Africa are using Bitcoin to protect sources and maintain financial independence.',
    content: 'Full blog content here...',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&q=80',
    author: 'Press Freedom',
    date: '2024-11-08',
    readTime: '8 min read'
  },
  {
    id: '13',
    title: 'From Learner to Leader: How a Bitcoin Meetup Changed My Life',
    slug: 'bitcoin-meetup-changed-life',
    excerpt: 'Attending a local Bitcoin meetup opened doors I never knew existed. Now I\'m helping others discover financial sovereignty.',
    content: 'Full blog content here...',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=800&q=80',
    author: 'Community Leader',
    date: '2024-11-03',
    readTime: '7 min read'
  },
  {
    id: '14',
    title: 'What is the Lightning Network? A Guide for Africans',
    slug: 'lightning-network-guide',
    excerpt: 'Understanding the Lightning Network and how it enables instant, low-cost Bitcoin transactions perfect for everyday use.',
    content: 'Full blog content here...',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&q=80',
    author: 'Bitcoin Educator',
    date: '2024-10-30',
    readTime: '10 min read'
  },
  {
    id: '15',
    title: 'How to Set Up Your First Bitcoin Wallet in 5 Minutes',
    slug: 'setup-first-bitcoin-wallet',
    excerpt: 'Step-by-step tutorial on choosing and setting up a secure Bitcoin wallet. Perfect for absolute beginners.',
    content: 'Full blog content here...',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80',
    author: 'Tech Guide',
    date: '2024-10-26',
    readTime: '6 min read'
  },
  {
    id: '16',
    title: 'Understanding Bitcoin Mining: Can Africans Participate?',
    slug: 'bitcoin-mining-africa',
    excerpt: 'Demystifying Bitcoin mining and exploring opportunities for African participation in securing the network.',
    content: 'Full blog content here...',
    category: 'Education',
    image: 'https://images.unsplash.com/photo-1621416894569-0f39ed31d247?w=800&q=80',
    author: 'Mining Expert',
    date: '2024-10-22',
    readTime: '9 min read'
  },

  // TECHNOLOGY & INNOVATION
  {
    id: '17',
    title: 'Solar-Powered Bitcoin Mining: A Solution for Rural Africa',
    slug: 'solar-bitcoin-mining',
    excerpt: 'Exploring how renewable energy and Bitcoin mining could bring economic opportunities to remote African communities.',
    content: 'Full blog content here...',
    category: 'Technology',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&q=80',
    author: 'Technology Writer',
    date: '2024-11-13',
    readTime: '9 min read'
  },
  {
    id: '18',
    title: 'African Developers Building Bitcoin Applications',
    slug: 'african-developers-bitcoin-apps',
    excerpt: 'Meet the talented African developers creating innovative Bitcoin solutions for local problems.',
    content: 'Full blog content here...',
    category: 'Technology',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80',
    author: 'Dev Community',
    date: '2024-11-09',
    readTime: '8 min read'
  },
  {
    id: '19',
    title: 'Bitcoin on Feature Phones: Making Crypto Accessible to All',
    slug: 'bitcoin-feature-phones',
    excerpt: 'New technology brings Bitcoin to basic mobile phones, opening access to millions of Africans without smartphones.',
    content: 'Full blog content here...',
    category: 'Technology',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80',
    author: 'Mobile Tech',
    date: '2024-11-04',
    readTime: '7 min read'
  },
  {
    id: '20',
    title: 'Blockchain Beyond Bitcoin: African Use Cases',
    slug: 'blockchain-african-use-cases',
    excerpt: 'How blockchain technology is solving real problems across Africa, from land registry to supply chain management.',
    content: 'Full blog content here...',
    category: 'Technology',
    image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?w=800&q=80',
    author: 'Blockchain Analyst',
    date: '2024-10-29',
    readTime: '11 min read'
  },

  // ECONOMY & FINANCE
  {
    id: '21',
    title: 'From Remittances to Financial Freedom',
    slug: 'remittances-financial-freedom',
    excerpt: 'African diaspora discovers Bitcoin as a faster, cheaper way to send money home, saving millions in transfer fees annually.',
    content: 'Full blog content here...',
    category: 'Economy',
    image: 'https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?w=800&q=80',
    author: 'Financial Journalist',
    date: '2024-11-11',
    readTime: '6 min read'
  },
  {
    id: '22',
    title: 'Bitcoin as a Hedge Against Currency Devaluation',
    slug: 'bitcoin-hedge-currency-devaluation',
    excerpt: 'How Africans are protecting their wealth from inflation and currency crashes using Bitcoin as a store of value.',
    content: 'Full blog content here...',
    category: 'Economy',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80',
    author: 'Economic Analyst',
    date: '2024-11-07',
    readTime: '8 min read'
  },
  {
    id: '23',
    title: 'Youth Building the Bitcoin Economy',
    slug: 'youth-building-bitcoin-economy',
    excerpt: 'African youth are leading the charge in Bitcoin adoption, creating innovative solutions for local challenges.',
    content: 'Full blog content here...',
    category: 'Economy',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80',
    author: 'Youth Reporter',
    date: '2024-11-01',
    readTime: '6 min read'
  },
  {
    id: '24',
    title: 'Bitcoin Savings Circles: The African Way',
    slug: 'bitcoin-savings-circles',
    excerpt: 'Traditional savings circles meet Bitcoin: How communities are combining cultural practices with modern technology.',
    content: 'Full blog content here...',
    category: 'Economy',
    image: 'https://images.unsplash.com/photo-1559526324-593bc073d938?w=800&q=80',
    author: 'Community Finance',
    date: '2024-10-27',
    readTime: '7 min read'
  },

  // SECURITY & PRIVACY
  {
    id: '25',
    title: 'Protecting Your Bitcoin: Essential Security Tips',
    slug: 'protecting-bitcoin-security-tips',
    excerpt: 'Learn how to keep your Bitcoin safe from hackers, scammers, and theft. A comprehensive security guide.',
    content: 'Full blog content here...',
    category: 'Security',
    image: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=800&q=80',
    author: 'Security Expert',
    date: '2024-11-12',
    readTime: '10 min read'
  },
  {
    id: '26',
    title: 'Hardware Wallets Explained: Are They Worth It?',
    slug: 'hardware-wallets-explained',
    excerpt: 'Everything you need to know about hardware wallets, from how they work to which ones are best for African users.',
    content: 'Full blog content here...',
    category: 'Security',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    author: 'Wallet Review',
    date: '2024-11-06',
    readTime: '8 min read'
  },
  {
    id: '27',
    title: 'Common Bitcoin Scams in Africa and How to Avoid Them',
    slug: 'bitcoin-scams-africa-avoid',
    excerpt: 'Stay safe! Learn to identify and avoid the most common Bitcoin scams targeting Africans.',
    content: 'Full blog content here...',
    category: 'Security',
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80',
    author: 'Consumer Protection',
    date: '2024-10-31',
    readTime: '9 min read'
  },
  {
    id: '28',
    title: 'Privacy in Bitcoin Transactions: What You Need to Know',
    slug: 'bitcoin-transaction-privacy',
    excerpt: 'Understanding Bitcoin privacy, why it matters, and practical steps to protect your financial information.',
    content: 'Full blog content here...',
    category: 'Security',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
    author: 'Privacy Advocate',
    date: '2024-10-24',
    readTime: '11 min read'
  },

  // COMMUNITY & EVENTS
  {
    id: '29',
    title: 'Bitcoin Conference Lagos 2024: Key Takeaways',
    slug: 'bitcoin-conference-lagos-2024',
    excerpt: 'Highlights from West Africa\'s largest Bitcoin conference, featuring speakers, workshops, and networking opportunities.',
    content: 'Full blog content here...',
    category: 'Community',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
    author: 'Event Coverage',
    date: '2024-11-10',
    readTime: '6 min read'
  },
  {
    id: '30',
    title: 'Starting a Bitcoin Meetup in Your City: A Guide',
    slug: 'starting-bitcoin-meetup-guide',
    excerpt: 'Want to organize a Bitcoin meetup in your community? Here\'s everything you need to know to get started.',
    content: 'Full blog content here...',
    category: 'Community',
    image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80',
    author: 'Community Builder',
    date: '2024-11-02',
    readTime: '7 min read'
  },
  {
    id: '31',
    title: 'African Bitcoin Podcasts You Should Be Listening To',
    slug: 'african-bitcoin-podcasts',
    excerpt: 'Discover the best African-focused Bitcoin podcasts educating and entertaining listeners across the continent.',
    content: 'Full blog content here...',
    category: 'Community',
    image: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=800&q=80',
    author: 'Media Curator',
    date: '2024-10-28',
    readTime: '5 min read'
  },
  {
    id: '32',
    title: 'Women in Bitcoin Africa: Breaking Barriers',
    slug: 'women-bitcoin-africa',
    excerpt: 'Celebrating African women leading Bitcoin adoption and education across the continent.',
    content: 'Full blog content here...',
    category: 'Community',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80',
    author: 'Women in Bitcoin',
    date: '2024-10-23',
    readTime: '8 min read'
  }
];

export const categories = [
  'All',
  'Adoption',
  'Regulations',
  'Education',
  'Technology',
  'Economy',
  'Security',
  'Community'
];

export const testimonials = [
  {
    id: '1',
    name: 'Amara O.',
    location: 'Lagos, Nigeria',
    text: 'Learning about Bitcoin changed my perspective on money. Now I have control over my financial future.',
    avatar: 'AO'
  },
  {
    id: '2',
    name: 'Kwame M.',
    location: 'Accra, Ghana',
    text: 'The education I received here helped me understand Bitcoin deeply. I can now teach others in my community.',
    avatar: 'KM'
  },
  {
    id: '3',
    name: 'Fatima S.',
    location: 'Nairobi, Kenya',
    text: 'Bitcoin gave me financial freedom I never thought possible. This education was life-changing.',
    avatar: 'FS'
  }
  ,
  {
    id: '4',
    name: 'Daniel K.',
    location: 'Kigali, Rwanda',
    text: "After attending a local workshop I started accepting Bitcoin for my designs — business grew 2x.",
    avatar: 'DK'
  },
  {
    id: '5',
    name: 'Zola T.',
    location: 'Cape Town, South Africa',
    text: 'The practical security lessons saved me from a phishing scam — I recommend this course to everyone.',
    avatar: 'ZT'
  },
  {
    id: '6',
    name: 'Nia A.',
    location: 'Kampala, Uganda',
    text: 'I used Bitcoin to receive remittances faster and cheaper. The guides here made it simple.',
    avatar: 'NA'
  },
  {
    id: '7',
    name: 'Oluwaseun B.',
    location: 'Ibadan, Nigeria',
    text: 'From learner to meetup organizer — I now teach others about custody and wallets.',
    avatar: 'OB'
  },
  {
    id: '8',
    name: 'Aisha M.',
    location: 'Mogadishu, Somalia',
    text: 'The community support connected me to developers building local payment tools.',
    avatar: 'AM'
  }
];

export const resources = [
  {
    id: '1',
    title: 'Bitcoin Beginner Guide (PDF)',
    description: 'A comprehensive guide for anyone starting their Bitcoin journey',
    type: 'PDF',
    downloadUrl: '#'
  },
  {
    id: '2',
    title: 'Recommended Bitcoin Wallets',
    description: 'Top secure wallets for storing your Bitcoin safely',
    type: 'Guide',
    downloadUrl: '#'
  },
  {
    id: '3',
    title: 'Security Best Practices',
    description: 'Essential security tips every Bitcoin user should know',
    type: 'PDF',
    downloadUrl: '#'
  },
  {
    id: '4',
    title: 'Bitcoin Glossary',
    description: 'Common Bitcoin terms and their meanings explained simply',
    type: 'Reference',
    downloadUrl: '#'
  }
];

export const features = [
  {
    id: '1',
    title: 'Education',
    description: 'We provide practical Bitcoin training for schools, youth, merchants, and communities, helping people understand and use Bitcoin confidently.',
    image: 'assets/education.jpg'
  },
  {
    id: '2',
    title: 'Storytelling',
    description: 'We document and share real stories of Bitcoin adoption across Africa, highlighting the people, challenges, and progress in each community.',
    image: 'assets/story.jpg'
  },
  {
    id: '3',
    title: 'Community Development ',
    description: 'We support communities in building sustainable Bitcoin circular economies through merchant onboarding, local spending, and hands-on guidance.',
    image: 'assets/communities.jpg'
  },
  {
    id: '4',
    title: 'Research and Insights',
    description: 'We study Bitcoin usage, community needs, adoption patterns, and emerging trends to guide our programs and share valuable insights with the ecosystem.',
    image: 'assets/research.jpg'
  }
];